import API from "@/api/";
import {ASSET_ROOT_FOLDER} from "../../../appConfig";

export const getRecshareAsset = ({ state, commit }, params) => {
  let recshareId;
  let newParams;
  ({ recshareId, ...newParams } = params);

  if (!recshareId) {
    return Promise.reject("recshareId is required");
  }

  let actualRtId;
  let musicAsset;
  return API.recshare.get(recshareId)
    .then( res => {
      actualRtId = res.data.assetRoot.id;
      const p = {parent: actualRtId};
      return API.asset.getContent(p)
    })
    .then( res2 => {
      musicAsset = res2.data.find( asset => asset.name === "Music");
      if (musicAsset) {
        newParams.parent = musicAsset.id;
        commit("setRootAssetId", actualRtId);
        commit("setParentIsEncrypt", musicAsset.isEncrypt);
        commit("setParentSource", musicAsset.source);
        return getAssetContent({state, commit}, newParams);
      }
      else {
        throw new Error("Failed to find the 'Music' folder");
      }
    })
}


export const getChannelMusicAsset = ({ commit }, params) => {
  let channelId;
  ({ channelId, } = params);

  if (!channelId) {
    return Promise.reject("channelId is required");
  }

  let actualRtId;
  let musicAsset;
  return API.channel.get(channelId)
    .then( res => {
      actualRtId = res.data.assetRoot.id;
      const p = {parent: actualRtId};
      return API.asset.getContent(p)
    })
    .then( res2 => {
      musicAsset = res2.data.find( asset => asset.name === "Music");
      if (musicAsset) {
        const fakeAssets = [{...musicAsset}];
        fakeAssets[0].name = ASSET_ROOT_FOLDER;
        commit("setRootAssetId", actualRtId);
        commit("setMusicAssetId", musicAsset.id);
        commit("setParent", actualRtId);
        commit(`SET_LIST`, fakeAssets);
        return fakeAssets;
      }
      else {
        throw new Error("Failed to find the 'Music' folder");
      }
    })
}


export const getChannelAsset = ({ state, commit }, params) => {
  let channelId;
  let newParams;
  ({ channelId, ...newParams } = params);

  if (!channelId) {
    return Promise.reject("channelId is required");
  }

  let actualRtId;
  let musicAsset;
  return API.channel.get(channelId)
    .then( res => {
      actualRtId = res.data.assetRoot.id;
      commit("setRootAssetId", actualRtId);
      const p = {parent: actualRtId};
      if(!res.data.isSystem) {
        return API.asset.getContent(p).then( res2 => {
          musicAsset = res2.data.find( asset => asset.name === "Music");
          if (musicAsset) {
            newParams.parent = musicAsset.id;
            commit("setMusicAssetId", musicAsset.id);
            commit("setParentIsEncrypt", musicAsset.isEncrypt);
            commit("setParentSource", musicAsset.source);
            return getAssetContent({state, commit}, newParams);
          }
          else {
            throw new Error("Failed to find the 'Music' folder");
          }
        })
      } else {
        newParams.parent = res.data.assetRoot.id;
        newParams.isSystem = true
        commit("setMusicAssetId", res.data.assetRoot.id);
        commit("setParentIsEncrypt", res.data.assetRoot.isEncrypt);
        commit("setParentSource", res.data.assetRoot.source);
        return getAssetContent({state, commit}, newParams);
      }

    })
    
    //.then( res3 => {
      ////commit("setRootAssetId", musicAsset.id);
      //console.log(`getChannelAsset: res3, before commit`);
      //commit("setRootAssetId", actualRtId);
      //return res3;
    //})
}

//NOTE: if params is not assigned, it will use the 'parent', 'sort', 'order' stored in the store
//      if "parent" is not assigned in "params", it will use the same "parent" saved in the store
const getAssetContent = ({ commit, state }, params = {}) => {
  let newParams;
  if (params) {
    newParams = {...params};
  }
  else {
    newParams = {order: state.order, sort: state.sort}
  }
  const {parent, isSystem } = newParams;
  if (!parent) {
    if (state.parent) {
      newParams.parent = state.parent;
    }
    else {
      return Promise.reject("parent ID is required");
    }
  }

  //console.log(`getAssetContent: state.rootAssetId = ${state.rootAssetId} newParams = ${JSON.stringify(newParams)}`);
  return API.asset.getContent(newParams).then(res => {
    if (res.status === 200) {

      if (state.rootAssetId === parent && !isSystem) {
        //console.log(`rootAssetId === parent`);
        const musicAsset = res.data.find( asset => asset.name === "Music");
        if (musicAsset && res.data.length == 1) {
          const fakeAssets = [{...musicAsset}];
          fakeAssets[0].name = ASSET_ROOT_FOLDER;
          commit(`SET_LIST`, fakeAssets);
          res.data = fakeAssets;
          //commit(`SET_LIST`, res.data);
        }
        else {
          commit(`SET_LIST`, res.data);
          //throw new Error("Failed to find the 'Music' folder");
        }
      }
      else {
        commit(`SET_LIST`, res.data);
      }
      if (parent) {
        commit("setParent", parent);
      }
    } else {
      // Message({
      //   message: res.data.message,
      //   type: 'error',
      //   duration: 10 * 1000
      // })
    }
    return res;
  });
};

export default {
  getChannelAsset,
  getChannelMusicAsset,
  getRecshareAsset,
  getAssetContent,
};
